import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "panel", "list"];
  static values = { url: String };

  connect() {
    this.boundDocClick = this.onDocumentClick.bind(this);
    document.addEventListener("click", this.boundDocClick);
  }

  disconnect() {
    document.removeEventListener("click", this.boundDocClick);
    clearTimeout(this.timeout);
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hidePanel();
    }
  }

  onFocus() {
    if (this.inputTarget.value.trim()) {
      this.scheduleSearch();
    }
  }

  search() {
    this.scheduleSearch();
  }

  scheduleSearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.performSearch(), 300);
  }

  close() {
    this.hidePanel();
  }

  async performSearch() {
    const q = this.inputTarget.value.trim();
    if (!q) {
      this.hidePanel();
      return;
    }

    const url = `${this.urlValue}?${new URLSearchParams({ query: q })}`;
    try {
      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      if (!response.ok) {
        this.hidePanel();
        return;
      }
      const data = await response.json();
      this.renderResults(data);
    } catch (_e) {
      this.hidePanel();
    }
  }

  renderResults(data) {
    const results = data.results || [];
    const viewMoreUrl = data.view_more_url || "/schools/pupils";

    this.listTarget.innerHTML = "";

    if (results.length === 0) {
      const empty = document.createElement("p");
      empty.className = "DriveatoNavPupilSearch-empty  m0  p1  u-textMuted";
      empty.textContent = "No pupils found";
      this.listTarget.appendChild(empty);
      this.showPanel();
      this.appendViewMore(viewMoreUrl);
      return;
    }

    results.forEach((row) => {
      const a = document.createElement("a");
      a.href = row.url;
      a.className =
        "DriveatoNavPupilSearch-result  u-linkClean  u-block  p1";
      a.dataset.turbo = "false";

      const title = document.createElement("div");
      title.className = "u-medium";
      title.textContent = row.name;
      a.appendChild(title);

      if (row.subtitle) {
        const sub = document.createElement("div");
        sub.className = "u-textSmall  u-textMuted";
        sub.textContent = row.subtitle;
        a.appendChild(sub);
      }

      this.listTarget.appendChild(a);
    });

    this.appendViewMore(viewMoreUrl);
    this.showPanel();
  }

  appendViewMore(viewMoreUrl) {
    const wrap = document.createElement("div");
    wrap.className = "DriveatoNavPupilSearch-footer  u-borderTop";

    const a = document.createElement("a");
    a.href = viewMoreUrl;
    a.className =
      "DriveatoNavPupilSearch-viewMore  u-linkClean  u-block  p1  u-textSmall  u-medium";
    a.textContent = "View more";
    a.dataset.turbo = "false";
    wrap.appendChild(a);

    this.listTarget.appendChild(wrap);
  }

  showPanel() {
    this.panelTarget.classList.remove("u-hidden");
    this.inputTarget.setAttribute("aria-expanded", "true");
  }

  hidePanel() {
    this.panelTarget.classList.add("u-hidden");
    this.listTarget.innerHTML = "";
    this.inputTarget.setAttribute("aria-expanded", "false");
  }

  // '/' keyboard shortcut
  connect() {
    this.boundDocClick = this.onDocumentClick.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);

    document.addEventListener("click", this.boundDocClick);
    document.addEventListener("keydown", this.boundKeydown);
  }

  disconnect() {
    document.removeEventListener("click", this.boundDocClick);
    document.removeEventListener("keydown", this.boundKeydown);
    clearTimeout(this.timeout);
  }

  onKeydown(e) {
    const active = document.activeElement;
    const isTyping =
      ["INPUT", "TEXTAREA"].includes(active.tagName) ||
      active.isContentEditable;

    if (isTyping) return;

    if (e.key === "/") {
      e.preventDefault();
      this.focusInput();
    }
  }

  focusInput() {
    this.inputTarget.focus();
    this.inputTarget.select();
  }
}
